import React, { useState } from "react";
import { InfoForm, InfoFormGray } from "~misc/icons";

const InfoCredit = ({ bg, text }) => {

  const [hovermouse, Sethovermouse] = useState(false);
  const whenHoveringMouse = () => Sethovermouse((prev) => !prev);
  return (
    <div
      className={
        bg == "blue"
          ? "flex items-center  info-blue relative"
          : "flex items-center gap-2"
      }
    >
      <span
        className="cursor-pointer "
        onMouseEnter={whenHoveringMouse}
        onMouseLeave={whenHoveringMouse}
      >
        {bg == "blue" ? (
          <>
          <InfoForm />
          </>
        ):(
          <>
          <InfoFormGray />
          </>
        )}
      </span>
      {hovermouse && (
        <div>
          <p
            className={
              bg == "blue"
                ? "px-[10px] p-[5px] bg-[#034EA2] rounded-lg text-primario text-sm flex flex-col items-center  text-white absolute w-[211px] text-start ml-2 z-40 top-0 "
                : "px-[10px] p-[5px] bg-[#E6E6E6] rounded-lg text-primario text-sm flex flex-col items-center relative z-40"
            }
          >
            {text ? text : "Não Possui Dupla Categoria"}
          </p>
        </div>
      )}
    </div>
  );
};

export default InfoCredit;
